import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import './i18n'

import { configureStore } from './store/store'
import { CookiesProvider } from 'react-cookie'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={configureStore({})}>
    <React.Fragment>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CookiesProvider>
    </React.Fragment>
  </Provider>
)
reportWebVitals()
// serviceWorker.unregister();
